// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_ky-1";
export var quotedThread = "_ky-0";